import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';
import compose from 'lib/enhancers/compose';
import styles from './PrescriptionDrugCoverage.module.scss';
import pdStyles from 'components/PlanData/PlanDetails/PlanDetails.module.scss';

import { TableCellData, TableColumnData, TableRowData, TableStyles } from 'components/helpers/Table/Table.types';
import Table from 'components/helpers/Table/Table';
import { UsedOption } from 'components/PlanData/Types/DrugCoverageTables.Type';

type PrescriptionDrugCoverageProps = {
  prescriptionDrugTables: UsedOption;
};

const cx = classNames.bind(styles);
const cxPlanDetail = classNames.bind(pdStyles);

const PrescriptionDrugCoverage = (props: PrescriptionDrugCoverageProps): JSX.Element => {
  const caption = props.prescriptionDrugTables.groupCaption;
  const tableResults = props.prescriptionDrugTables.drugCoverageTables || [];

  return (
    <div className={cx('prescription-drug-coverage', cxPlanDetail('container-edge'))}>
      <RichText
        tag="h2"
        className={cxPlanDetail('section-header', 'prescription-drug-coverage-section-header')}
        field={{ value: caption }}
      />
      {tableResults?.map((tableResult, index) => {
        const tableCaption = tableResult.caption;
        const tableId = `${tableCaption.replace(/[^a-zA-Z0-9]/g, '-')}-id`; // Generate unique id

        const columnDataArray: TableColumnData[] = [{ styles: { color: 'gray-15' } }];
        const rowDataArray: TableRowData[] = [];

        tableResult.columnGroup.columns.forEach((colGroup, index) => {
          if (index != 0) {
            const columnColor = colGroup.color as
              | 'gray-15'
              | 'gray-60'
              | 'purple-10'
              | 'purple-60'
              | 'teal-10'
              | 'transparent'
              | 'white'
              | undefined;
            const columnDataItem: TableColumnData = { styles: { color: columnColor } };
            columnDataArray.push(columnDataItem);
          }
        });

        tableResult?.rows.forEach((row) => {
          const cellDataArray: TableCellData[] = [];
          row.cells.forEach((cell) => {
            const cellHeader = cell.isHeader || false;
            const cellDataItem: TableCellData = {
              children: <RichText field={{ value: cell.label }} />,
              isHeader: cellHeader,
            };
            cellDataArray.push(cellDataItem);
          });
          const rowDataItem: TableRowData = { cellData: cellDataArray };
          rowDataArray.push(rowDataItem);
        });
        const tableStyles: TableStyles = { align: 'middle', border: 'bottom' };
        return (
          <section key={index} className={cx('prescription-drug-coverage-table')}>
            <Table
              id={tableId}
              caption={tableCaption}
              columnData={columnDataArray}
              rowData={rowDataArray}
              styles={tableStyles}
            />
          </section>
        );
      })}
    </div>
  );
};

export default compose<PrescriptionDrugCoverageProps>()(PrescriptionDrugCoverage);
